import React from 'react';

import { MaterialPropertyValuePair } from '@paragon/client-tools';
import { RoofContainer } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';

import { updateRoofContainer } from '../../../../store/actions/layout/roofContainerActions';
import { getDistanceFormatterSelector } from '../../../../store/selectors/getDistanceFormatterSelector';
import { isLayoutModeViewOnly } from '../../../../store/selectors/layoutModeSelectors';
import { propertiesShouldBeViewOnly } from '../../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { ProjectHierarchyContextSelects } from './ProjectHierarchyContextSelects';
import { PropertiesPanelMenuButton } from './PropertiesPanelMenuButton';

export function RoofContainerProperties({ value: roofContainer }: { value: RoofContainer }) {
  const dispatch = useAppDispatch();
  const distanceFormatter = useAppSelector(getDistanceFormatterSelector);
  const viewOnlyProperties = useAppSelector(propertiesShouldBeViewOnly);
  const viewOnlyLayout = useAppSelector(isLayoutModeViewOnly);
  const viewOnly = viewOnlyProperties || viewOnlyLayout;

  const baseRoofElevation = roofContainer.solidData
    ? Math.min(...roofContainer.solidData.vertices.map((vertex) => vertex.z))
    : null;

  return (
    <PropertiesPanel
      title="Roof Container Properties"
      titleButton={<PropertiesPanelMenuButton type="roofContainer" guid={roofContainer.guid} />}
    >
      <MaterialPropertyValuePair property="Name" value={roofContainer.name} />

      <ProjectHierarchyContextSelects
        levelGuid={roofContainer.levelGuid}
        onChange={(levelGuid) => dispatch(updateRoofContainer({ ...roofContainer, levelGuid }))}
        disabled={viewOnly}
      />

      <MaterialPropertyValuePair
        property="Base Elevation"
        value={baseRoofElevation != null ? distanceFormatter(baseRoofElevation) : 'Unknown'}
      />
    </PropertiesPanel>
  );
}
